import { commonFunc } from "./common/_index.js";
import { homeFunc } from "./pages/_home.js";
import { cWebFunc } from "./pages/_cWeb.js";
import { affiliationStoreFunc } from "./pages/_affiliationStore.js";
import ScrollHint from 'scroll-hint';

/**
 * メインルーチン
 */
window.addEventListener( 'load', function () {
  // scroll hintの発火
  new ScrollHint('.js-scrollable', {
    scrollHintIconAppendClass: 'scroll-hint-icon-black',
    applyToParents: true,
    i18n: {
      scrollable: 'スクロールできます'
    }
  });

  commonFunc();
  homeFunc();
  cWebFunc();
  affiliationStoreFunc();
} );
